import React, { Fragment } from 'react';
import ScrollLock from 'react-scrolllock';
import './instructions.css';
import map from '../../../../images/ParkingLots/Instructions/Ottawa/map.png';
import entrance1 from '../../../../images/ParkingLots/Instructions/Ottawa/car-entrance.png';
import entrance2 from '../../../../images/ParkingLots/Instructions/Ottawa/car-entrance-2.png';
import entrance3 from '../../../../images/ParkingLots/Instructions/Ottawa/walk-entrance.png';
import { Helmet } from 'react-helmet';

const ByWardInstructions = () => (
  <Fragment>
    <Helmet>
      <title>Autzu | Parking Instructions</title>
      <meta
        name="description"
        content="Rent a car to drive and earn on ridesharing platforms with no upfront payments or term-commitments. From only $7/hour, we provide a pre-qualified car and include maintenance, insurance, parking and 24/7 roadside assistance."
      />
    </Helmet>
    <div className="instructions">
      <ScrollLock>
        <div className="instructions__container">
          <div className="instructions__title_container">
            <div className="instructions__title">
              Finding the Parking Hub
            </div>
            <div className="instructions__subtitle">
              ByWard Market - Downtown Ottawa
            </div>
            <p>41 George St, Ottawa, ON K1N 8W5</p>
          </div>

          <div className="instructions__body">
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>How do I access the parking lot?</strong>
              </div>
              <br />
              <img className="instructions__image" src={map} />
              <br />
              <p className="instructions__body-text">
                Autzu EV vehicles are parked on Level P4 of the Indigo
                Parking Lot at 41 George St in the ByWard Market. The main
                entrance is opposite Hudson’s Bay on George St, and can
                also be accessed on York St by car.
              </p>
            </div>
            <br />
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>How do I access the parking lot by car?</strong>
              </div>
              <p className="instructions__body-text">
                There are driving entrances to the garage on George St and
                York St.
              </p>
              <br />
              <img className="instructions__image" src={entrance1} />
              <br />
              <p className="instructions__body-text">
                Enter the parking lot on George St. and tap the reserved
                parking card at the entrance gate to open it. Once the gate
                opens, pull through and keep to the left to go up the ramp.
                Follow the Autzu signage to P4.
              </p>
              <br />
              <img className="instructions__image" src={entrance2} />
              <br />
              <p className="instructions__body-text">
                Alternatively, enter the parking lot on York St. and tap
                the reserved parking card at the entrance gate to open it.
                Once the gate opens, pull through and keep to the right to
                go up the ramp. Follow the Autzu signage to P4.
              </p>
            </div>
            <br />
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>
                  How do I access the parking lot by walking?
                </strong>
              </div>
              <p className="instructions__body-text">
                The public parking elevator can be accessed via the door on
                the left of the car entrance on George St. Enter the door
                and take the elevator to P4. Once you arrive at P4, turn
                left, and you will see the Autzu cars.
              </p>
              <br />
              <img className="instructions__image" src={entrance3} />
            </div>
          </div>
        </div>
      </ScrollLock>
    </div>
  </Fragment>
);

export default ByWardInstructions;



// WEBPACK FOOTER //
// ./src/components/Static/ParkingLots/Ottawa/ByWardInstructions.js